function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useEffect } from 'react';
import CheckCircleIcon from '@heroicons/react/20/solid/CheckCircleIcon';
import { Translate } from "../../../../../I18N";
import { InputField } from "../../../../Components/Forms";
import { Button, Card, Sidepanel } from "../../../../Components/UI";
import { useFieldArray, useForm } from 'react-hook-form';
import uniqueID from "../../../../../../shared/uniqueID";









const ThesauriGroupFormSidepanel = ({
  submit,
  closePanel,
  value,
  showSidepanel
}) => {
  const defaultValues = {
    label: '',
    values: [{ label: '', _id: `temp_${uniqueID()}` }],
    _id: `temp_${uniqueID()}`
  };
  const {
    watch,
    reset,
    control,
    setValue,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onSubmit',
    defaultValues: value
  });

  const { append, fields } = useFieldArray({ control, name: 'values', keyName: 'tempId' });

  useEffect(() => {
    if (value) {
      reset(value);
    } else {
      reset(defaultValues);
    }
  }, [value]);

  useEffect(() => {
    const subscription = watch((formData) => {
      const values = formData.values;
      // @ts-ignore
      if (Boolean(values.length) && values[values.length - 1].label !== '') {
        // @ts-ignore
        append({ label: '', _id: `temp_${uniqueID()}` }, { shouldFocus: false });
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, append]);

  const curateBeforeSubmit = (tValue) => {var _tValue$values;
    const filteredValues = (_tValue$values = tValue.values) === null || _tValue$values === void 0 ? void 0 : _tValue$values.filter((fValue) => fValue.label && fValue.label !== '');

    submit(_objectSpread(_objectSpread({
      _id: tValue._id },
    (tValue === null || tValue === void 0 ? void 0 : tValue.id) && { id: tValue.id }), {}, {
      label: tValue.label,
      values: filteredValues })
    );
    reset(defaultValues);
    closePanel();
  };

  const renderItem = () =>
  fields.map((localValue, index) => /*#__PURE__*/
  _jsx("div", { className: "mt-2" }, localValue.tempId, /*#__PURE__*/
  _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Item") }, void 0, /*#__PURE__*/
  _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
  React.createElement(InputField, _extends({
    id: "item-name",
    "data-testid": "thesauri-form-item-name",
    label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Title") },
  register(`values.${index}.label`))
  )
  )
  )
  )
  );

  return /*#__PURE__*/(
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      closeSidepanelFunction: closePanel,
      title:
      value && value.label !== '' ? /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Edit group") : /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Add group") }, void 0, /*#__PURE__*/



    _jsx("form", {
      onSubmit: handleSubmit(curateBeforeSubmit),
      id: "group-thesauri-form",
      className: "flex flex-col h-full" }, void 0, /*#__PURE__*/

    _jsx(Sidepanel.Body, {}, void 0,
    value && value.label === '' && /*#__PURE__*/
    _jsx("div", { className: "p-4 mb-4 rounded-md border border-gray-50 shadow-sm bg-primary-100 text-primary-700" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-1 items-center w-full text-base font-semibold" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "w-5 h-5 text-sm" }, void 0, /*#__PURE__*/
    _jsx(CheckCircleIcon, {})
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Adding a group and its items.")
    ), /*#__PURE__*/
    _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "You can add one or many items in this form."), /*#__PURE__*/
    _jsx("br", {}), /*#__PURE__*/
    _jsx(Translate, { translationKey: "thesauri new group desc" }, void 0, "Each item created will live inside this group. Once you type the first item name, a new item form will appear underneath it, so you can keep on adding as many as you want."



    )
    )
    ), /*#__PURE__*/

    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Group") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "group-name",
      "data-testid": "thesauri-form-item-name",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Name") },
    register('label', { required: true }), {
      hasErrors: !!errors.label,
      clearFieldAction: () => setValue('label', '') })
    )
    )
    ),
    renderItem()
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "bottom-0 px-4 py-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "light",
      onClick: closePanel,
      className: "grow",
      "data-testid": "menu-form-cancel" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "grow", type: "submit", "data-testid": "thesaurus-form-submit" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add")
    )
    )
    )
    )
    ));

};

export { ThesauriGroupFormSidepanel };